import React, { Fragment } from 'react';
import { Breadcrumbs } from '../../AbstractElements';
import DataTablesContain from '../../Component/Tables/DataTable2';
import { useTranslation } from 'react-i18next';

const DataTable2 = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Breadcrumbs parent={t("Dashboard")} title={t("User List")} />
      <DataTablesContain />
    </Fragment>
  );
};
export default DataTable2;
